Vue.component("MpModuleBulletin", {
    props: {
        title: String,
        sourceUrl: String,
        delayVariation: Number,
        showCta: Boolean,
        sendLabel: String,
        sendUrl: String,
        gotoLabel: String,
        gotoUrl: String,
    },
    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            DESC_MAX_LENGTH: 180,

            carousel: null,

            adList: [],

            isInitialized: false,
        };
    },
    computed: {},
    methods: {
        formatDescription: function(description) {
            return description.slice(0, this.DESC_MAX_LENGTH) + '...';
        },

        next: function() {
            this.carousel.slideNext();
        },

        previous: function() {
            this.carousel.slidePrev();
        },

        initSwiper: function() {

            if (!this.$refs.carousel) {
                return;
            }

            this.carousel = new Swiper(this.$refs.carousel, {
                slidesPerView: 'auto',
                allowTouchMove: false,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: this.delayVariation + Math.round(this.delayVariation * Math.random()),
                }
            });
        },

        onAdsLoaded: function(response) {

            if (response.statusText !== this.RESPONSE_OK) {
                return;
            }

            this.adList = response.data.adverts;
            Vue.nextTick(this.initSwiper);
        },

        loadAds: function() {
            axios
                .post(this.sourceUrl)
                .then(this.onAdsLoaded)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.isInitialized = true;
            this.loadAds();
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section>\
        <div class="swiper-container" ref="carousel">\
            <h4 class="mini-gallery__title">{{title}}</h4>\
\
            <a class="mini-gallery__nav-btn mini-gallery__nav-btn--prev" href="#" @click.prevent="previous()"></a>\
            <a class="mini-gallery__nav-btn mini-gallery__nav-btn--next" href="#" @click.prevent="next()"></a>\
\
            <div class="swiper-wrapper">\
\
                <div class="swiper-slide" v-for="ad in adList">\
                    <article class="post-mini">\
                        <img class="post-mini__img" :src="ad.thumb1" v-if="ad.hasImages">\
\
                        <h3 class="post-mini__title">\
                            <a class="post-mini__title-link" :href="ad.url">{{ad.title}}</a>\
                        </h3>\
\
                        <p class="post-mini__text" v-html="formatDescription(ad.description)"></p>\
                    </article>\
                </div>\
            </div>\
        </div>\
\
        <ul class="mini-gallery__links" v-if="showCta">\
            <li class="mini-gallery__links-item">\
                <a class="mini-gallery__link" :href="sendUrl">{{sendLabel}}</a>\
            </li>\
            <li class="mini-gallery__links-item">\
                <a class="mini-gallery__link mini-gallery__link--dark" :href="gotoUrl">{{gotoLabel}}</a>\
            </li>\
        </ul>\
\
    </section>',
});
